import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {brandColor, primaryTextColor} from "~/theme";

export default function UITabs({className, ...props}) {
  const classes = useStyles();

  return (
    <div
      className={cn(classes.root, className)}
      {...props}
    />
  );
}


export function UITab({tagName: Tag, className, selected, ...props}) {
  const classes = useStyles();

  return (
    <Tag
      className={cn(classes.tab, {[classes.tabSelected]: selected}, className)}
      {...props}
    />
  );
}

UITab.defaultProps = {
  tagName: 'div'
};


const useStyles = createUseStyles({
  root: {
    display: 'flex',
    borderBottom: [[1, 'solid', '#eee']],

    '& $tab': {
      margin: [[0, 0, -1]]
    },

    '& $tab + $tab': {
      marginLeft: 12
    }
  },

  tab: {
    padding: [[9, 2, 7]],
    borderBottom: [[2, 'solid', 'transparent']],
    color: primaryTextColor,
    letterSpacing: 0.25,
    cursor: 'pointer',
    transition: [['border', '100ms', 'linear']],

    '&:hover': {
      borderColor: '#ccc',
    }
  },

  tabSelected: {
    fontWeight: 500,
    lineHeight: '15px',
    paddingBottom: 1,
    letterSpacing: 0,

    borderColor: brandColor,
    '&:hover': {
      borderColor: brandColor,
    }
  },
});
